import { useEffect } from "react";

import { connect, useDispatch } from "react-redux";
import { Navigate } from "react-router";

import { AuthActionCreators } from "../../store/actions/auth";
import { SiteActions } from "../../store/actions/site";

const AuthLogout = ({ logout }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    logout();
    dispatch({ type: SiteActions.INVALIDATE_SITES });
  }, []);
  return <Navigate to="/auth/login" />;
};

export default connect(null, (dispatch) => ({
  logout: () => dispatch(AuthActionCreators.logout()),
}))(AuthLogout);
